import { Token, TokenType } from '../../domain/models/Token'
import { TokenWithPermissions } from '../../domain/models/TokenWithPermissions'
import { JWTToken } from '../../infrastructure/models/JWTToken'
import { TokenData } from '../../domain/repositories/ITokenRepository'

export class TokenFactory {
  /**
   * Create token from stored data
   */
  static createFromStoredData(data: TokenData): Token | TokenWithPermissions {
    const expiresAt = data.expiresAt ? new Date(data.expiresAt) : null
    
    if (data.type === 'access') {
      // Access tokens are always JWT with permissions
      return JWTToken.createAccessToken(data.value)
    }
    
    // Other tokens are simple tokens
    return new Token(data.value, data.type, expiresAt)
  }
  
  /**
   * Create access token (always JWT)
   */
  static createAccessToken(value: string): TokenWithPermissions {
    return JWTToken.createAccessToken(value)
  }
  
  /**
   * Create refresh token (simple string)
   */
  static createRefreshToken(value: string, expiresIn: number): Token {
    return Token.createRefreshToken(value, expiresIn)
  }
}
